<template>
  <el-dialog
    v-model="state.visible"
    :title="$t('cart.riskReminder')"
    class="dialog-wrapper risk-reminder"
    :show-close="false"
    :close-on-click-modal="false"
    width="420px"
  >
    <template #header>
      <div class="dialog-header">
        <el-icon :size="20" color="var(--white-color-1)">
          <WarningFilled />
        </el-icon>
        <span class="header-title">{{ $t('cart.riskReminder') }}</span>
      </div>
    </template>
    <div class="wrapper">
      <div class="keyword-block">
        <span class="box1">{{
          state.riskType === 1 ? $t('cart.blackenedShop') : $t('cart.riskProducts')
        }}</span>
        <span v-if="state.riskType === 1" class="box2">{{
          $props.goods?.sellerInfo?.shopName
        }}</span>
      </div>
      <div class="tip-msg" v-html="tipMsg"></div>
    </div>

    <template #footer>
      <div class="footer">
        <span
          v-if="state.riskType === 1 || state.riskType === 2"
          class="continue-btn"
          @click="goOtherFun"
          >{{ $t('cart.continueToBuy') }}</span
        >
        <span v-if="state.riskType === 3" class="buy-other-btn" @click="goOtherFun">{{
          $t('cart.buyOthers')
        }}</span>
        <span v-if="state.riskType === 3" class="continue-purchase-btn" @click="continueFun">{{
          $t('cart.continuePurchasing')
        }}</span>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, defineExpose, defineProps, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
const $router = useRouter()
const { t } = useI18n()
const $props = defineProps({
  goods: {
    type: Object,
    default: () => ({}),
  },
})
const state = reactive({
  visible: false,
  riskType: 3,
})
const tipMsg = computed(() => {
  let msg = ''
  if (state.riskType === 1) {
    msg = t('cart.riskMsg1')
  } else if (state.riskType === 2) {
    msg = t('cart.riskMsg2')
  } else if (state.riskType === 3) {
    msg = $props.goods.riskTips
  }
  return msg
})
const openModal = (type) => {
  state.visible = true
  state.riskType = type
}
const goOtherFun = () => {
  $router.push({ name: 'home' })
}
const continueFun = () => {
  state.visible = false
}
defineExpose({
  openModal,
})
</script>

<style lang="scss" scoped>
.dialog-wrapper {
  .dialog-header {
    background-color: var(--border-black-1);
    border-radius: 8px 8px 0 0;
    height: 64px;
    padding-left: 40px;
    display: flex;
    align-items: center;

    .header-title {
      font-size: 16px;
      font-weight: bold;
      color: var(--white-color-1);
      margin-left: 8px;
    }
  }

  .wrapper {
    padding: 0 40px;

    .keyword-block {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .box1 {
        font-size: 14px;
        font-weight: 500;
        padding: 6px 12px;
        border-radius: 4px;
        color: #fa5151;
        margin-top: 16px;
        background: #ffdfdf;
        border: 2px solid #fa5151;
        margin-right: 10px;
      }

      .box2 {
        padding: 6px 12px;
        border-radius: 4px;
        border: 1px dashed var(--black-color-1-dark);
        font-size: 14px;
        font-weight: bold;
        color: var(--black-common-color-9);
        margin-top: 16px;
      }
    }

    .tip-msg {
      margin-top: 20px;
      font-size: 12px;
      font-weight: normal;
      line-height: 18px;
      color: var(--black-common-color-6);
    }
  }

  .footer {
    margin-top: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;

    .continue-btn {
      cursor: pointer;
      display: block;
      padding: 0 24px;
      height: 44px;
      line-height: 44px;
      background: var(--black-color-1-dark);
      border-radius: 519px;
      color: rgba(255, 255, 255, 0.9);
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      margin: auto;
    }

    .buy-other-btn {
      padding: 0 24px;
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      border: 1px solid var(--black-color-1-dark);
      border-radius: 519px;
      font-size: 14px;
      font-weight: bold;
      color: rgba(58, 58, 58, 0.9);
      text-align: center;
    }

    .continue-purchase-btn {
      padding: 0 24px;
      height: 44px;
      line-height: 44px;
      cursor: pointer;
      border-radius: 519px;
      text-align: center;
      background: var(--black-color-1-dark);
      color: rgba(255, 255, 255, 0.9);
    }
  }
}
</style>
